import React, { Fragment } from 'react';
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Services from "../components/Services";
import BrandLogo from "../components/BrandLogo";
import Funfact from "../components/Funfact";
import CallToAction from "../components/CallToAction";
import Footer from "../components/Footer";
import LoginRegister from "../components/LoginRegister";
import MobileMenu from "../components/MobileMenu";
import Features from "../components/Features";
import Testimonial from "../components/Testimonials/home-two";
import Team from "../components/Team/home-two";
import SpecialismSection from "../components/SpecialismSection";
import MoreDetails from "../components/MoreDetails";

import ServiceThumb from '../assets/img/about.jpg'
import { color } from '@mui/system';
import HeaderTwo from '../components/Header/indextwo';
import MobileMenuTwo from '../components/MobileMenu/indextwo';
import FooterTwo from '../components/Footer/indextwo';
import CallToActionTwo from '../components/CallToAction/indextwo';
import AboutTwoPage from '../components/About/about-two/indexpage';

const PageAbout = () => {
    const customAboutText = {
        // Custom values if needed
        "title": "ABOUT US",
        "heading": "About Us",
        "since": "Since 2024",
        "text": "<p>At Phantom Global, we understand that entrusting the care of your loved ones is a deeply personal decision. Our mission is to provide exceptional homecare services that empower individuals to live with dignity, independence, and comfort in the familiar surroundings of their own homes.</p> <p><strong>Our Services</strong></p> <p>We offer a wide range of personalised care services tailored to meet the unique needs of each client:</p> <p>• Personal Care: Assistance with daily activities such as bathing, dressing, grooming, and mobility support.</p> <p>• Companionship: Providing emotional support and meaningful interaction to combat loneliness.</p> <p>• Specialist Care: Tailored support for individuals with dementia, physical disabilities, or other complex care needs.</p> <p>• Medication Management: Helping with reminders and administration in line with care plans.</p> <p>• Live-In Care: Around-the-clock care for clients who require continuous support and supervision.</p> <p>• Domestic Assistance: Support with household tasks such as cleaning, laundry, and meal preparation.</p> <p>• Palliative Care: Compassionate end-of-life care focused on comfort and dignity.</p> <p><strong>Why Choose Phantom Global?</strong></p> <p>• Expert Carers: Our carers are rigorously selected and undergo comprehensive training to provide professional, compassionate, and reliable care.</p> <p>• Personalised Approach: We design bespoke care plans in collaboration with families, healthcare professionals, and local authorities to ensure the best outcomes.</p> <p>• Holistic Support: Our focus extends beyond physical needs to include emotional and social well-being, ensuring a truly comprehensive approach to care.</p> <p>• Trusted Partnerships: We work closely with families and maintain open communication to foster trust and peace of mind.</p> <p>Your Peace of Mind, Our Priority</p> <p>When you choose Phantom Global, you’re choosing a partner dedicated to enhancing the quality of life for your loved ones. We are here to support you every step of the way, offering flexibility and adaptability as needs change. With our team, you can rest assured knowing your family is in safe and capable hands.</p> <p>To learn more about our services or to discuss your specific needs, please contact us on 0207 139 5110 or email us at info@phantomglobal.co.uk.</p> <p>Phantom Global: Care you can trust, when you need it most.</p>",
        "btnText": "Contact us",
        "btnLink": "/homecare/contact",
        "thumb": "/about-homecaree.jpg"
    };
    return (
        <Fragment>
            <HeaderTwo/>
            <PageHeader
                bgImg={require('../assets/img/homecare2.jpg')}
                title="ABOUT US"
                content=""
            />
            <AboutTwoPage customAbout={customAboutText} />
            <Features classes={'sm-top'} />
            <Funfact ribbonColor="#BB2649" />
            <CallToActionTwo/>
            <FooterTwo/>
            <LoginRegister />
            <MobileMenuTwo />
        </Fragment>
    );
};

export default PageAbout;